import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import ScrollArea from '../../../partials/ScrollArea'

import style from './style'

export const GroupTable = props => {
  return (
    <ScrollArea
      style={{
        height: `300px`
      }}
    >
      <Col>
        <Row
          className={css(
            style.list.header,
            style[props.theme.name] ? style[props.theme.name].list.header : null
          )}
        />
        {props.groups.map((group, index) => (
          <GroupRow
            theme={props.theme}
            key={index}
            onClick={() => props.onGroupExpand(group.id)}
            isActive={props.activeGroup.id === group.id}
            group={group}
          />
        ))}
      </Col>
    </ScrollArea>
  )
}

export const GroupRow = props => {
  const permCount = Object.keys(props.group.permissions || {}).length

  return (
    <Row
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.isActive
          ? style[props.theme.name]
            ? (style.list.rowActive, style[props.theme.name].list.rowActive)
            : style.list.rowActive
          : null
      )}
      onClick={props.onClick}
    >
      <Col>
        <Row>
          <Col>
            <span
              className={css(
                style.group.name,
                style[props.theme.name]
                  ? style[props.theme.name].group.name
                  : null
              )}
            >
              {props.group.name}
            </span>
          </Col>
          <Col />
          <Col xs='auto'>
            <span
              className={css(
                style.group.permCount,
                style[props.theme.name]
                  ? style[props.theme.name].group.permCount
                  : null
              )}
            >
              {permCount === 1
                ? `${permCount} permission`
                : `${permCount} permissions`}
            </span>
          </Col>
        </Row>
        <Row
          className={css(
            style.list.permRow,
            style[props.theme.name]
              ? style[props.theme.name].list.permRow
              : null,
            props.isActive
              ? style[props.theme.name]
                ? (style.list.permRowActive,
                  style[props.theme.name].list.permRowActive)
                : style.list.permRowActive
              : null
          )}
        >
          <Col>
            <Row>
              {Object.keys(props.group.permissions || {}).map((key, index) => (
                <Col xs='4' lg='4' xl='3' key={`perm_${key}_${index}`}>
                  <span style={{ fontSize: `13px` }}>{key}</span>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default GroupTable



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupTable/index.js